module.exports = __webpack_public_path__ + "img/chu_ky_moc.69b8db52.png";